import React, { ReactElement } from 'react';
import cx from 'classnames';
import { CatCard } from '@blocks-react/components/Card';
import { CatIconChevronRight } from '@blocks-react/components/Icons/ChevronRight';
import { CatIconArrowForward } from '@blocks-react/components/Icons/ArrowForward';
import { CatHeading } from '@blocks-react/components/Heading';
import styles from './CatValueCard.module.scss';

type CatValueCardProps = {
  className?: string;
  title: string;
  icon: ReactElement;
  content: string;
  redirectUrl: string;
  target: string;
  nltext: string;
};

export const CatValueCard = ({
  className='',
  title,
  icon,
  content,
  redirectUrl,
  target,
  nltext
}: Readonly<CatValueCardProps>) => {
  const handleRedirectCatValueLink = (link: string, target = '_self') => {
    window.open(link, target);
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      handleRedirectCatValueLink(redirectUrl, target);
    }
  };

  return (
    <CatCard
      className={cx(styles['cat_value_card'], { [styles[className]]: className })}
      tabIndex={0}
      aria-label={`${title} clickable card`}
      onClick={() => handleRedirectCatValueLink(redirectUrl, target)}
      onKeyDown={handleKeyDown}
      data-track-event="e_primaryCTA"
      data-track-attr-nltext={nltext}
      data-track-attr-context="Why Genuine cat parts"
    >
      <div className="d-flex gap-3 align-items-center align-items-md-start py-lg-2">
        {icon}
        <div className="d-flex flex-md-column flex-grow-1 flex-lg-grow-0 justify-content-between align-items-center gap-1 ">
          {/* title and icon */}
          <div className="d-flex w-100 justify-content-between gap-2 align-items-center align-items-md-start">
            <CatHeading
              level="h3"
              variant="title-sm"
              color="knockout"
              className="text-center d-block"
            >
              {title}
            </CatHeading>
            <div className="d-block d-lg-none">
              <CatIconChevronRight color="knockout-brand" />
            </div>
            <div
              className={cx(
                'd-none d-lg-block position-absolute',
                styles['arrow_upward']
              )}
            >
              <CatIconArrowForward />
            </div>
          </div>
          {/* content */}
          <CatHeading
            variant="body"
            color="knockout"
            className="d-none d-md-block"
          >
            {content}
          </CatHeading>
        </div>
      </div>
    </CatCard>
  );
};
